<div [class]="timerConfig?.timerClass ? timerConfig.timerClass : ''">
	<span *ngIf="timerObj.hours > 0"
		><span>{{ timerObj.hours }}</span
		><span class="time-category">{{
			timerTextConfig && timerTextConfig.hourText ? timerTextConfig.hourText : ':'
		}}</span></span
	>
	<span>{{ timerObj.mins }}</span
	><span class="time-category">{{
		timerTextConfig && timerTextConfig.minuteText ? timerTextConfig.minuteText : ':'
	}}</span>
	<span>{{ timerObj.seconds }}</span
	><span class="time-category">{{
		timerTextConfig && timerTextConfig.secondsText ? timerTextConfig.secondsText : ' '
	}}</span>
</div>
